export default "__VITE_ASSET__C5rBp2YH__"